import ResidentPortfolioTemplate from "app/features/residents/templates/view/ResidentPortfolioTemplate";

export default function PortfolioScreen() {
  return <ResidentPortfolioTemplate />;
}
